export default __webpack_public_path__ + "static/media/democratizing_speed_2.192696a1.png";